export const PREMIUM_METRICS_CTA = {
  FREE: {
    TITLE: 'Available only in paid plan',
    SUB_TITLE:
      'See your data your way with even more granular visibility and custom dashboards for project and git metrics.',
    BUTTON_TEXT: 'Book a demo'
  },
  PAID: {
    TITLE: '"All contributors" is a limited view',
    SUB_TITLE: 'Select a team or a group from the selector above',
    BUTTON_TEXT: false
  }
};
